import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGreenAddDepartmentIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Group_6509",
	"data-name": "Group 6509",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	width: 17.305,
	height: 21.526,
	viewBox: "0 0 17.305 21.526",
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1202",
				"data-name": "Rectangle 1202",
				width: 17.305,
				height: 21.526,
				fill: "#1da193"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-2",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1196",
				"data-name": "Rectangle 1196",
				width: 6.815,
				height: 15.021,
				fill: "#1da193"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-3",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1197",
				"data-name": "Rectangle 1197",
				width: 6.075,
				height: 15.036,
				fill: "#1da193"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-4",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1198",
				"data-name": "Rectangle 1198",
				width: 6.254,
				height: 15.036,
				fill: "#1da193"
			})
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip-path-5",
			children: /* @__PURE__ */ _jsx("rect", {
				id: "Rectangle_1199",
				"data-name": "Rectangle 1199",
				width: 4.341,
				height: 4.341,
				fill: "#1da193"
			})
		})
	] }), /* @__PURE__ */ _jsxs("g", {
		id: "Group_4846",
		"data-name": "Group 4846",
		clipPath: "url(#clip-path)",
		children: [
			/* @__PURE__ */ _jsx("g", {
				id: "Group_4830",
				"data-name": "Group 4830",
				transform: "translate(5.284 6.505)",
				style: { isolation: "isolate" },
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4829",
					"data-name": "Group 4829",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_4828",
						"data-name": "Group 4828",
						clipPath: "url(#clip-path-2)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_7748",
							"data-name": "Path 7748",
							d: "M56.445,62.913v4.98a.31.31,0,0,1-.091.217,2.548,2.548,0,0,1-1.159.629.306.306,0,0,0-.229.294v6.53a.305.305,0,0,1-.108.233,2.151,2.151,0,0,1-.443.285.3.3,0,0,1-.133.03H51.814a.3.3,0,0,1-.14-.033,2.131,2.131,0,0,1-.467-.327.308.308,0,0,1-.1-.225V69.01a.307.307,0,0,0-.247-.3,1.507,1.507,0,0,1-1.218-1.005.307.307,0,0,1-.014-.1V62.772a.3.3,0,0,1,.017-.1,2.507,2.507,0,0,1,1.4-1.366c.02-.01.04-.017.061-.026a2.672,2.672,0,0,1,.972-.186h.02a.3.3,0,0,1,.224.106l.279.323h0l.213.248a.3.3,0,0,0,.461,0l.1-.121.094-.109.294-.342A.305.305,0,0,1,54,61.092h.059a2.382,2.382,0,0,1,.909.183l.007,0a2.561,2.561,0,0,1,1.459,1.548.31.31,0,0,1,.012.088",
							transform: "translate(-49.63 -61.091)",
							fill: "#1da193"
						})
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_4833",
				"data-name": "Group 4833",
				transform: "translate(11.23 5.078)",
				style: { isolation: "isolate" },
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4832",
					"data-name": "Group 4832",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_4831",
						"data-name": "Group 4831",
						clipPath: "url(#clip-path-3)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_7749",
							"data-name": "Path 7749",
							d: "M111.544,49.262v5.22a.293.293,0,0,1-.028.128,1.329,1.329,0,0,1-.079.14,1.374,1.374,0,0,1-.988.6.3.3,0,0,0-.255.3v6.518a.307.307,0,0,1-.11.235,2.184,2.184,0,0,1-.483.3.3.3,0,0,1-.128.027h-2.383l-.136-.031a2.17,2.17,0,0,1-.519-.356.31.31,0,0,1-.1-.226V57.08a.3.3,0,0,1,.128-.247,1.708,1.708,0,0,0,.506-.535.294.294,0,0,0,.037-.147v-5.28a.308.308,0,0,0-.013-.089,4.063,4.063,0,0,0-.658-1.268,3.009,3.009,0,0,0-.73-.7.3.3,0,0,1-.027-.49,2.824,2.824,0,0,1,.758-.444,2.671,2.671,0,0,1,.671-.168,2.394,2.394,0,0,1,.3-.019,1.745,1.745,0,0,1,.183.009h0l.343.4.234.271a.3.3,0,0,0,.461,0l.189-.219.3-.352a.3.3,0,0,1,.227-.106h0a2.392,2.392,0,0,1,.94.2,2.637,2.637,0,0,1,1.32,1.239.3.3,0,0,1,.029.131",
							transform: "translate(-105.47 -47.696)",
							fill: "#1da193"
						})
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_4836",
				"data-name": "Group 4836",
				transform: "translate(0 5.078)",
				style: { isolation: "isolate" },
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4835",
					"data-name": "Group 4835",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_4834",
						"data-name": "Group 4834",
						clipPath: "url(#clip-path-4)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_7750",
							"data-name": "Path 7750",
							d: "M4.77,50.633v5.524a.3.3,0,0,0,.03.133,1.654,1.654,0,0,0,.385.49.3.3,0,0,1,.1.224v5.138a.306.306,0,0,1-.1.23,2.108,2.108,0,0,1-.41.279q-.053.028-.107.053a.3.3,0,0,1-.126.027H2.152a.3.3,0,0,1-.135-.031,2.175,2.175,0,0,1-.487-.328.308.308,0,0,1-.1-.229V55.607a.307.307,0,0,0-.232-.3,1.506,1.506,0,0,1-1.117-.887A1.346,1.346,0,0,1,0,53.957a1.1,1.1,0,0,1,.057-.372.329.329,0,0,0,.021-.111V49.411a.305.305,0,0,1,.017-.1,2.421,2.421,0,0,1,1.332-1.354,2.227,2.227,0,0,1,.864-.177c.064,0,.127,0,.19.008a.308.308,0,0,1,.209.105l.269.312.147.17a.3.3,0,0,0,.461,0l.136-.158.348-.4A.31.31,0,0,1,4.26,47.7q.105-.009.212-.009a2.125,2.125,0,0,1,.3.021,2.19,2.19,0,0,1,.514.135,2.488,2.488,0,0,1,.885.593.3.3,0,0,1-.092.485,2.59,2.59,0,0,0-.793.567,1.707,1.707,0,0,0-.514,1.137",
							transform: "translate(0 -47.695)",
							fill: "#1da193"
						})
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_4839",
				"data-name": "Group 4839",
				transform: "translate(1.186)",
				style: { isolation: "isolate" },
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4838",
					"data-name": "Group 4838",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_4837",
						"data-name": "Group 4837",
						clipPath: "url(#clip-path-5)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_7751",
							"data-name": "Path 7751",
							d: "M15.475,2.171A2.171,2.171,0,1,1,13.3,0a2.171,2.171,0,0,1,2.171,2.171",
							transform: "translate(-11.134)",
							fill: "#1da193"
						})
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_4842",
				"data-name": "Group 4842",
				transform: "translate(6.553 1.436)",
				style: { isolation: "isolate" },
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4841",
					"data-name": "Group 4841",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_4840",
						"data-name": "Group 4840",
						clipPath: "url(#clip-path-5)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_7752",
							"data-name": "Path 7752",
							d: "M65.885,15.659a2.171,2.171,0,1,1-2.171-2.171,2.171,2.171,0,0,1,2.171,2.171",
							transform: "translate(-61.544 -13.488)",
							fill: "#1da193"
						})
					})
				})
			}),
			/* @__PURE__ */ _jsx("g", {
				id: "Group_4845",
				"data-name": "Group 4845",
				transform: "translate(11.903)",
				style: { isolation: "isolate" },
				children: /* @__PURE__ */ _jsx("g", {
					id: "Group_4844",
					"data-name": "Group 4844",
					children: /* @__PURE__ */ _jsx("g", {
						id: "Group_4843",
						"data-name": "Group 4843",
						clipPath: "url(#clip-path-5)",
						children: /* @__PURE__ */ _jsx("path", {
							id: "Path_7753",
							"data-name": "Path 7753",
							d: "M116.135,2.171A2.171,2.171,0,1,1,113.965,0a2.171,2.171,0,0,1,2.171,2.171",
							transform: "translate(-111.794)",
							fill: "#1da193"
						})
					})
				})
			})
		]
	})]
});
export { SvgGreenAddDepartmentIcon as ReactComponent };
